import validate from "/vercel/path1/node_modules/.pnpm/nuxt@3.12.3_@parcel+watcher@2.4.1_@types+node@14.18.33_ioredis@5.4.1_magicast@0.3.4_rollup@4._lttpmlzorgh6yp5bdjwirzntyi/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/vercel/path1/node_modules/.pnpm/nuxt@3.12.3_@parcel+watcher@2.4.1_@types+node@14.18.33_ioredis@5.4.1_magicast@0.3.4_rollup@4._lttpmlzorgh6yp5bdjwirzntyi/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}